// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Explore',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'events',
    path: '/dashboard/events',
    icon: icon('ic_cart'),
  }, 
  {
    title: 'inbox',
    path: '/dashboard/inbox',
    icon: icon('ic_user'),
  },

  {
    title: 'Gallery',
    path: '/dashboard/explore',
    icon: icon('ic_blog'),
  },
  {
    title: 'Share',
    path: '/dashboard/blog',
    icon: icon('ic_blog'),
  },
  {
    title: 'profile',
    path: '/dashboard/profile',
    icon: icon('ic_lock'),
  }, 
];

export default navConfig;
